module.exports = __webpack_public_path__ + "images/homepage-playstore.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-playstore.png
// module id = 866
// module chunks = 0